module.exports = __webpack_public_path__ + "img/1999_S.b2fa155a.png";